import { Component, Input } from '@angular/core';
import { CustomerReplyPortalReplyModel } from '../../core/models/customer-reply-portal-reply-model.model';
import { UserAvatarComponent } from '../../../sb-modules/Frontend-User-Avatar-Module/user-avatar.component';
import { FilePreviewComponent } from '@sb-document-viewer/components/file-preview/file-preview.component';
import { ReplaceEmojisPipe } from '@sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';
import { TicketEmailTimePipe } from '@sb-tools/typescript/pipes/ticket/ticket-email-time.pipe';
import { PrepareMessagePipe } from '@sb-tools/typescript/pipes/ticket/prepare-message.pipe';

@Component({
    selector: 'app-ticket-reply',
    templateUrl: './ticket-reply.component.html',
    styleUrls: ['./ticket-reply.component.scss'],
    imports: [UserAvatarComponent, FilePreviewComponent, ReplaceEmojisPipe, TicketEmailTimePipe, PrepareMessagePipe],
})
export class TicketReplyComponent {
    @Input() reply: CustomerReplyPortalReplyModel;
}
